// custom-tabs.js
import * as bootstrap from 'bootstrap';

(function () {
    'use strict';

    let isProgrammaticHashChange = false; // Flag to indicate a programmatic hash change

    document.addEventListener('DOMContentLoaded', function () {
        // Add #link-tab on click
        var navLinks = document.querySelectorAll('.nav-tabs .nav-link');

        navLinks.forEach(function (link) {
            link.addEventListener('shown.bs.tab', function (e) {

                if (!isProgrammaticHashChange) { // Only update history if not programmatic
                    history.pushState({}, '', link.href);
                }
                isProgrammaticHashChange = false; // Reset the flag
            });
        });

        // Select the tab corresponding to the URL's hash
        let hash = window.location.hash;
        if (hash) {
            
            let params = hash.split("|");//We want to discard whatever comes after |
                hash = params[0];
            let separators = hash.split("#");
            for (let i = 1; i < separators.length && i < 2; i++) { // Start from index 1
                let tabTrigger = document.querySelector(`.nav-tabs a[href="#${separators[i]}"]`);
                if (tabTrigger) {
                    isProgrammaticHashChange = true; // Set the flag for programmatic change
                    new bootstrap.Tab(tabTrigger).show(); // Activate the tab
                }
            }
        }

    });

})();
